/* eslint-disable eqeqeq */
import React from 'react';
import './project info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message, Image } from "antd";
import { ImageSection, MainCardContent, ModalForFinancialCollection, ModalForMedia, ModalForAttachment, ModalForCampaign, MediaTable, AttachmentsTable, CampaignsTable } from './projectInfoDesign';
import moment from 'moment';
import { CSVLink } from 'react-csv';
let headers = [
    { label: "الشقه", key: "title" },
    { label: "الحاله", key: "status" },
    { label: "المشترى", key: "clientName" },
    { label: "رقم الجوال", key: "clientPhone" },
    { label: "رقم الهويه", key: "clientIdNumber" },
    { label: "السعر الاساسى", key: "price" },
    { label: "قيمه الخصم", key: "discount" },
    { label: "سعر البيع", key: "finalPrice" },
    { label: "تم دفع عربون؟", key: "isPaidDeposit" },
    { label: "قيمه العربون", key: "deposit" },
    { label: "وسيله دفع العربون", key: "depositPayType" },
    { label: "تم ارجاع العربون؟", key: "isDepositRefund" },
    { label: "نوع الشراء", key: "paymentType" },
    { label: "تاريخ الافراغ", key: "completedDate" },
    { label: "تم الافرغ؟", key: "isCompleted" },
    { label: "تاريخ التسليم", key: "deliveredDate" },
    { label: "تم التسليم؟", key: "isDelivered" },
    { label: " البائع", key: "employee" },
    { label: "ملاحظات", key: "notes" },
];

let csvData = [

];
class ProjectInfo extends React.Component {
    state = {
        csvData: [],
        csv2Data: [],
        actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
        id: this.props.location.state.data.id,
        name_en: this.props.location.state.data.name_en,
        name_ar: this.props.location.state.data.name_ar,
        description_en: this.props.location.state.data.description_en,
        description_ar: this.props.location.state.data.description_ar,
        tag: this.props.location.state.data.tag,
        profileUrl: this.props.location.state.data.profileUrl,
        available: this.props.location.state.data.available,
        totalPrice: this.props.location.state.data.totalPrice,
        totalViews: this.props.location.state.data.totalViews ? this.props.location.state.data.totalViews : 0,
        ownerName: this.props.location.state.data.owner ? this.props.location.state.data.owner.fullname : '',
        ownerPhone: this.props.location.state.data.owner ? this.props.location.state.data.owner.phone : '',
        ownerPassword: '',
        img: this.props.location.state ? this.props.location.state.data.img !== "" ? this.props.location.state.data.img : null : null,
        imgType: 'url',
        imgName: '',
        employees: this.props.location.state.data.employees ? this.props.location.state.data.employees : [],
        supportEmployee: this.props.location.state.data.supportEmployee ? this.props.location.state.data.supportEmployee : [],
        targetSales: this.props.location.state.data.targetSales ? this.props.location.state.data.targetSales.length > 0 ? this.props.location.state.data.targetSales : [{ monthDate: null, ratio: 0, target: 0 }] : [],
        commissionRatio: this.props.location.state.data.commissionRatio ? this.props.location.state.data.commissionRatio : 0,
        totalCollected: 0,
        collectedCount: 0,
        totalNotCollected: 0,
        notCollectedCount: 0,
        bookedCount: 0,
        totalBooked: 0,
        users: [],
        page: 1,
        pages: 1,
        report: [],
        projectUnits: [],
        modal: false,
        collectedForUnits: [],
        collectionReciept: null,
        collectionRecieptType: 'data',
        collectionRecieptName: '',
        modalMedia: false,
        assets: [],
        page2: 1,
        pages2: 1,
        media: null,
        mediaType: 'data',
        mediaName: '',
        thumbnail: null,
        thumbnailType: 'data',
        thumbnailName: '',
        modalAttachment: false,
        attachments: [],
        attachment: null,
        attachmentType: 'data',
        attachmentName: '',
        attachmentContent: '',
        attachmentStartDate: null,
        attachmentEndDate: null,
        attachmentStatus: '',
        page3: 1,
        pages3: 1,
        modalCampaign: false,
        campaigns: [],
        campaignContent: '',
        campaignType: '',
        campaignCost: 0,
        page4: 1,
        pages4: 1

    };

    constructor(props) {
        super(props)
        this.getData()
        this.getProjectAssets(1)
        this.getProjectAttachments()
        this.getProjectCampaigns()
        this.getProjectUnits()
        this.getUserWithoutPagenation()
        this.getReport(1)
        window.scrollTo(0, 0)
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }
    }

    componentDidMount() {
        if (this.props.isRTL) {
            allStrings.setLanguage('ar')
        } else {
            allStrings.setLanguage('en')
        }

    }
    getData = () => {
        axios.get(`${BASE_END_POINT}projects/${this.state.id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log('project  ', response.data)
                this.setState({
                    name_en: response.data.data.name_en,
                    name_ar: response.data.data.name_ar,
                    description_en: response.data.data.description_en,
                    description_ar: response.data.data.description_ar,
                    tag: response.data.data.tag,
                    profileUrl: response.data.data.profileUrl,
                    available: response.data.data.available,
                    totalPrice: response.data.data.totalPrice,
                    totalViews: response.data.data.totalViews ? response.data.data.totalViews : 0,
                    ownerName: response.data.data.owner ? response.data.data.owner.fullname : '',
                    ownerPhone: response.data.data.owner ? response.data.data.owner.phone : '',
                    img: response.data.data.img !== "" ? response.data.data.img : null,
                    employees: response.data.data.employees ? response.data.data.employees : [],
                    supportEmployee: response.data.data.supportEmployee ? response.data.data.supportEmployee : [],
                    targetSales: response.data.data.targetSales.length > 0 ? response.data.data.targetSales : [{ monthDate: null, ratio: 0, target: 0 }],
                    totalCollected: response.data.data.totalCollected,
                    collectedCount: response.data.data.collectedCount,
                    totalNotCollected: response.data.data.totalNotCollected,
                    notCollectedCount: response.data.data.notCollectedCount,
                    bookedCount: response.data.data.bookedCount,
                    totalBooked: response.data.data.totalBooked,
                    commissionRatio: response.data.data.commissionRatio ? response.data.data.commissionRatio : 0,
                    loading: false,
                })
            })
            .catch(error => {
                console.log('project ERROR  ', error)
                console.log('project ERROR  ', error.respose)
            })
    }

    getProjectAssets = (page) => {
        axios.get(`${BASE_END_POINT}projectAssets/${this.state.id}/withPagenation/get?limit=5&page=${page}`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log(response.data)
                this.setState({
                    assets: response.data.data,
                    page2: parseInt(response.data.page),
                    pages2: response.data.pageCount
                })
            })
            .catch(error => {
                console.log("ALL Assets ERROR")
                console.log(error.response)
            })
    }
    getProjectAttachments = (page) => {
        axios.get(`${BASE_END_POINT}projectAttachments/${this.state.id}/withPagenation/get?limit=5&page=${page}`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log(response.data)
                this.setState({
                    attachments: response.data.data,
                    page3: parseInt(response.data.page),
                    pages3: response.data.pageCount
                })
            })
            .catch(error => {
                console.log("ALL Assets ERROR")
                console.log(error.response)
            })
    }
    getProjectCampaigns = (page) => {
        axios.get(`${BASE_END_POINT}projectCampaigns/${this.state.id}/withPagenation/get?limit=5&page=${page}`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log(response.data)
                this.setState({
                    campaigns: response.data.data,
                    page4: parseInt(response.data.page),
                    pages4: response.data.pageCount
                })
            })
            .catch(error => {
                console.log("ALL Assets ERROR")
                console.log(error.response)
            })
    }
    getUserWithoutPagenation = () => {
        axios.get(`${BASE_END_POINT}quickSearch/get?type=SUB-ADMIN`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en',
            },
        }).then(response => {
            console.log(response.data.data)
            this.setState({ users: response.data.data })
        })
            .catch(error => {
                console.log("ALL users ERROR")
                console.log(error.response)
            })
    }
    getProjectUnits = () => {
        axios.get(`${BASE_END_POINT}ads/liveSearch/get?all=true&isCollected=false&hasAdvertisementParent=true&project=${this.state.id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en',
            },
        }).then(response => {
            console.log("projectUnits", response.data.data)
            this.setState({ projectUnits: response.data.data })
        })
            .catch(error => {
                console.log("ALL projectUnits ERROR")
                console.log(error.response)
            })
    }

    getReport = () => {
        axios.get(`${BASE_END_POINT}projects/${this.state.id}/getProjectReport`, {
            headers: {
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            }
        })
            .then(response => {
                console.log("reports   ", response.data)
                csvData = response.data.data.map(item => {
                    return {
                        ...{ title: item.title },
                        ...{
                            status: item.status == "SOLD" ? allStrings.sold : item.status == "BOOKED" ? allStrings.booked
                                : item.status == "BOOKED-WITHOUT-PAY" ? allStrings.bookedWithoutPay :
                                    item.status == "DELIVERED" ? allStrings.deliverd : item.status == "COMPLETED" ? allStrings.completedUnit : allStrings.available
                        },
                        ...{ clientName: item.clientName ? item.clientName : '--' },
                        ...{ clientPhone: item.clientPhone ? "\t" + item.clientPhone : '--' },
                        ...{ clientIdNumber: item.clientIdNumber ? item.clientIdNumber : '--' },
                        ...{ price: item.price },
                        ...{ discount: item.discount },
                        ...{ finalPrice: item.finalPrice },
                        ...{ isPaidDeposit: item.isPaidDeposit ? allStrings.yes : allStrings.no },
                        ...{ deposit: item.deposit },
                        ...{ depositPayType: item.depositPayType ? item.depositPayType === "SAAEI" ? 'ساعى' : item.depositPayType === "DEVELOPER" ? 'المطور' : '--' : '--' },
                        ...{ isDepositRefund: item.isDepositRefund ? allStrings.yes : allStrings.no },
                        ...{ paymentType: item.paymentType ? item.paymentType === "BANK" ? allStrings.bank : item.paymentType === "CASH" ? allStrings.cash : item.paymentType === "ONLINE" ? allStrings.online : '--' : '--' },
                        ...{ completedDate: item.completedDate ? moment(item.completedDate).format("dddd D MMMM YYYY hh:mm A") : '--' },
                        ...{ isCompleted: item.isCompleted ? allStrings.yes : allStrings.no },
                        ...{ deliveredDate: item.deliveredDate ? moment(item.deliveredDate).format("dddd D MMMM YYYY hh:mm A") : '--' },
                        ...{ isDelivered: item.isDelivered ? allStrings.yes : allStrings.no },
                        ...{ employee: item.employeeName ? item.employeeName : '--' },
                        ...{ notes: item.notes }
                    };
                });
                console.log(csvData)
                this.setState({ csvData: csvData })
            })
            .catch(error => {
                console.log("error   ", error.response)
                this.setState({ loading: false })
            })
    }


    update = () => {
        const { profileUrl, totalPrice, name_en, name_ar, description_en, description_ar, tag, img, imgType, employees, supportEmployee,
            ownerName, ownerPhone, ownerPassword, totalViews, commissionRatio } = this.state
        if (hasValue(name_en) && hasValue(name_ar) && hasValue(tag) && img != null) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()

            console.log("mmm", ownerName, ownerPhone, ownerPassword)
            data.append('name_en', name_en)
            data.append('name_ar', name_ar)
            data.append('description_en', description_en)
            data.append('description_ar', description_ar)
            data.append('profileUrl', profileUrl)
            data.append('tag', tag)
            data.append('totalViews', totalViews)
            data.append('commissionRatio', commissionRatio)
            if (ownerName) data.append('ownerName', ownerName)
            if (ownerPhone) data.append('ownerPhone', ownerPhone)
            if (ownerPassword) data.append('ownerPassword', ownerPassword)
            data.append('totalPrice', totalPrice)
            data.append('employees', JSON.stringify(employees))
            if (supportEmployee) data.append('supportEmployee', supportEmployee)

            if (img != null && imgType === "data") {
                data.append('img', img)
            }
            let targetSales = this.state.targetSales
                .filter(e => e && e.monthDate)
                .map(e => ({
                    monthDate: moment(e.monthDate, [
                        moment.ISO_8601,
                        "dddd D MMMM YYYY hh:mm A"
                    ]).locale('en').format("YYYY-MM-DD"),
                    ratio: Number(e.ratio) || 0,
                    target: Number(e.target) || 0
                }))
                .filter((obj, index, self) =>
                    index === self.findIndex(o => o.monthDate === obj.monthDate)
                );
            if (targetSales.length > 0) {
                data.append('targetSales', JSON.stringify(targetSales))
            }
            console.log(Array.from(data))
            axios.put(`${BASE_END_POINT}projects/${this.props.location.state.data.id}`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("project UPDATED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
                })
        }
    }

    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}projects/${this.props.location.state.data.id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("project DELETED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    removeAsset = (id) => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}projectAssets/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("asset DELETED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.getProjectAssets()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    addAsset = () => {
        const { media, thumbnail } = this.state
        if (media !== null) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('media', media)
            data.append('thumbnail', thumbnail)
            axios.post(`${BASE_END_POINT}projectAssets/${this.state.id}/createAsset`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("projectAsset ADDED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.setState({
                        modalMedia: false,
                        media: null,
                        mediaName: '',
                        thumbnail: null,
                        thumbnailName: ''

                    })
                    this.getProjectAssets(this.state.page2, false)
                })
                .catch(error => {
                    console.log("error   ", error.response)
                    console.log("error2   ", error)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    removeAttachment = (id) => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}projectAttachments/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("attachment DELETED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.getProjectAttachments(this.state.page3)
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    addAttachment = () => {
        const { attachment, attachmentContent, attachmentStartDate, attachmentEndDate, fileNumber } = this.state
        if (attachment !== null && attachmentContent !== null && attachmentStartDate !== null && attachmentEndDate !== null) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('content', attachmentContent)
            data.append('startDate', attachmentStartDate)
            data.append('endDate', attachmentEndDate)
            data.append('fileNumber', fileNumber)
            data.append('file', attachment)
            axios.post(`${BASE_END_POINT}projectAttachments/${this.state.id}/createAttachment`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("projectAttachment ADDED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.setState({
                        modalAttachment: false,
                        attachmentContent: null,
                        attachmentStartDate: null,
                        attachmentEndDate: null
                    })
                    this.getProjectAttachments(this.state.page3)
                })
                .catch(error => {
                    console.log("error   ", error.response)
                    console.log("error2   ", error)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    addCampaign = () => {
        const { campaignContent, campaignType, campaignCost } = this.state
        if (campaignContent !== null && campaignType !== null) {
            let l = message.loading('Wait..', 2.5)
            let data = {
                content: campaignContent,
                type: campaignType,
                cost: campaignCost
            }

            axios.post(`${BASE_END_POINT}projectCampaigns/${this.state.id}/createCampaign`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("projectCampaign ADDED  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.setState({
                        modalCampaign: false,
                        campaignContent: null,
                        campaignType: null,
                        campaignCost: null
                    })
                    this.getProjectCampaigns(this.state.page4)
                })
                .catch(error => {
                    console.log("error   ", error.response)
                    console.log("error2   ", error)
                    l.then(() => message.error(allStrings.error, 2.5))
                })
        }
    }
    removeCampaign = (id) => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}projectCampaigns/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en'
            },
        })
            .then(response => {
                console.log("Campaign DELETED")
                l.then(() => message.success(allStrings.done, 2.5))
                this.getProjectCampaigns(this.state.page3)
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }


    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.update()
    };

    changeHandler = event => {
        const toEnglishDigits = s => String(s).replace(/[٠-٩]/g, d => '0123456789'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)]);

        const value = toEnglishDigits(event.target.value);
        this.setState({ [event.target.name]: value });

        if (event.target.name === "totalPrice") {
            const newTargetSales = this.state.targetSales.map(val => {
                const ratio = Number(toEnglishDigits(val.ratio));
                const total = Number(value);
                return {
                    ...val,
                    ratio,
                    target: (ratio * total) / 100
                };
            });
            this.setState({ targetSales: newTargetSales });
        }
    };


    handleChangeState = (fieldName, value) => {
        this.setState({ [fieldName]: value });
    };

    fileChangedHandler = event => {
        this.setState({
            img: event.target.files[0],
            imgName: event.target.files[0].name,
            imgType: "data"
        })
    }
    removeFile = () => {
        this.setState({
            img: null,
            imgName: '',
            imgType: "url"
        });
    }
    fileChangedHandlerCollectionReciept = event => {
        this.setState({
            collectionReciept: event.target.files[0],
            collectionRecieptName: event.target.files[0].name,
            collectionRecieptType: "data"
        })
    }
    removeFileCollectionReciept = () => {
        this.setState({
            collectionReciept: null,
            collectionRecieptName: '',
            collectionRecieptType: "url"
        });
    }
    notAvailable = () => {
        let l = message.loading('Wait..', 2.5)
        axios.put(`${BASE_END_POINT}projects/${this.props.location.state.data.id}/notAvailable`, {}, {
            headers: {
                'Content-Type': 'applications/json',
                'Authorization': `Bearer ${this.props.currentUser.token}`,
                'Accept-Language': this.props.isRTL ? 'ar' : 'en',
            }
        })
            .then(response => {
                l.then(() => message.success(allStrings.done, 2.5))
                this.props.history.goBack()
            })
            .catch(error => {
                console.log(error.response)
                l.then(() => message.error(allStrings.error, 2.5))
            })
    }
    financialCollection = () => {
        const { collectedForUnits, collectionReciept, collectionRecieptType } = this.state
        if (collectedForUnits.length > 0 && collectionReciept != null) {
            let l = message.loading('Wait..', 2.5)
            let data = new FormData()
            data.append('collectedForUnits', JSON.stringify(collectedForUnits))
            if (collectionReciept != null && collectionRecieptType === "data") {
                data.append('collectionReciept', collectionReciept)
            }
            console.log(Array.from(data))
            axios.put(`${BASE_END_POINT}projects/${this.props.location.state.data.id}/financialCollection`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${this.props.currentUser.token}`,
                    'Accept-Language': this.props.isRTL ? 'ar' : 'en'
                },
            })
                .then(response => {
                    console.log("project collection  ", response.data)
                    l.then(() => message.success(allStrings.done, 2.5))
                    this.toggle()
                    this.props.history.goBack()
                })
                .catch(error => {
                    console.log(error.response)
                    l.then(() => message.error(error.response.data.errors[0].msg, 2.5))
                })
        }
    }
    submitHandlerFinancialCollection = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.financialCollection()
    };
    toggle = () => {
        this.setState({
            modal: !this.state.modal,
        });
    }
    submitHandlerMedia = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.addAsset()
    };
    toggleMedia = () => {
        this.setState({
            modalMedia: !this.state.modalMedia,
        });
    }
    fileChangedHandlerMedia = event => {
        this.setState({
            media: event.target.files[0],
            mediaName: event.target.files[0].name,
            mediaType: "data"
        })
    }
    removeMedia = () => {
        this.setState({
            media: null,
            mediaName: '',
            mediaType: "url"
        });
    }
    fileChangedHandlerThumbnail = event => {
        this.setState({
            thumbnail: event.target.files[0],
            thumbnailName: event.target.files[0].name,
            thumbnailType: "data"
        })
    }
    removeThumbnail = () => {
        this.setState({
            thumbnail: null,
            thumbnailName: '',
            thumbnailType: "url"
        });
    }
    toggleAttachment = () => {
        this.setState({
            modalAttachment: !this.state.modalAttachment,
        });
    }
    fileChangedHandlerAttachment = event => {
        this.setState({
            attachment: event.target.files[0],
            attachmentName: event.target.files[0].name,
            attachmentType: "data"
        })
    }
    removeAttachmentFile = () => {
        this.setState({
            attachment: null,
            attachmentName: '',
            attachmentType: "url"
        });
    }
    submitHandlerAttachment = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.addAttachment()
    }

    toggleCampaign = () => {
        this.setState({
            modalCampaign: !this.state.modalCampaign,
        });
    }
    submitHandlerCampaign = (event) => {
        event.preventDefault();
        event.target.className += " was-validated";
        this.addCampaign()
    }

    render() {
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROJECTS')) return <Redirect to='/Home' />
        let canSeeReport = true
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROJECT-REPORTS')) {
            canSeeReport = false
        }
        let canDoFinancialCollection = true;
        if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('COLLECTION')) {
            canDoFinancialCollection = false
        }
        return (
            <div className="App">
                <MDBContainer>
                    <ModalForFinancialCollection
                        isOpen={this.state.modal}
                        toggle={this.toggle}
                        submitHandler={this.submitHandlerFinancialCollection}
                        changeHandler={this.changeHandler}
                        state={this.state}
                        isRTL={this.props.isRTL}
                        allStrings={allStrings}
                        handleChangeState={this.handleChangeState}
                        fileChangedHandler={this.fileChangedHandlerCollectionReciept}
                        removeReciept={this.removeFileCollectionReciept}
                    />
                    <ModalForMedia
                        isOpen={this.state.modalMedia}
                        toggle={this.toggleMedia}
                        submitHandlerMedia={this.submitHandlerMedia}
                        state={this.state}
                        allStrings={allStrings}
                        fileChangedHandlerMedia={this.fileChangedHandlerMedia}
                        removeMedia={this.removeMedia}
                        fileChangedHandlerThumbnail={this.fileChangedHandlerThumbnail}
                        removeThumbnail={this.removeThumbnail}
                    />
                    <ModalForAttachment
                        isOpen={this.state.modalAttachment}
                        toggle={this.toggleAttachment}
                        submitHandlerAttachment={this.submitHandlerAttachment}
                        state={this.state}
                        allStrings={allStrings}
                        fileChangedHandlerAttachment={this.fileChangedHandlerAttachment}
                        removeAttachmentFile={this.removeAttachmentFile}
                        handleChangeState={this.handleChangeState}
                        isRTL={this.props.isRTL}
                    />
                    <ModalForCampaign
                        isOpen={this.state.modalCampaign}
                        toggle={this.toggleCampaign}
                        submitHandlerCampaign={this.submitHandlerCampaign}
                        state={this.state}
                        allStrings={allStrings}
                        handleChangeState={this.handleChangeState}
                        isRTL={this.props.isRTL}
                    />
                    {this.state.actionType === "VIEW" &&
                        <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
                            <MDBCol md='12'>
                                <MDBBtn onClick={() => { this.delete() }} rounded style={{ display: 'inline-block', width: 'fit-content', margin: '8px', background: 'linear-gradient(135deg, #FF3547, #B71C1C)', color: '#fff', borderRadius: '10px' }} color="FF3547" className="btn-block z-depth-1a">
                                    <MDBIcon icon="trash-alt" className="mr-2" />
                                    {allStrings.remove}
                                </MDBBtn>
                                <MDBBtn
                                    onClick={() => { this.notAvailable() }}
                                    color="none"
                                    style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                    rounded
                                    className="btn-block z-depth-1a"
                                >
                                    {allStrings.convetToNotAvailable}

                                </MDBBtn>
                                {canDoFinancialCollection &&
                                    <MDBBtn
                                        rounded
                                        color="none"
                                        style={{ display: 'inline-block', width: 'fit-content', margin: '8px', borderRadius: '10px', padding: '10px', background: '#fff', color: '#127275', border: '1px solid #127275' }}
                                        className="btn-block z-depth-1a"
                                        onClick={this.toggle}
                                    >
                                        {allStrings.financialCollection}
                                    </MDBBtn>
                                }
                                {canSeeReport &&
                                    <CSVLink
                                        data={this.state.csvData}
                                        headers={headers}
                                        filename={`حاله مشروع ${this.state.name_ar}.csv`}
                                        style={{ padding: '1px', position: 'relative' }}
                                    >
                                        <MDBBtn
                                            color="none"
                                            style={{ display: 'inline-block', width: 'fit-content', margin: '8px', padding: '10px', background: '#fff', color: '#127275', borderRadius: '10px', border: '1px solid #127275' }}
                                            rounded
                                            className="btn-block z-depth-1a"
                                        >
                                            {allStrings.downloadReport}
                                        </MDBBtn>
                                    </CSVLink>
                                }
                            </MDBCol>
                        </MDBRow>
                    }
                    <MDBRow style={{ flexFlow: this.props.isRTL ? 'row-reverse' : 'row' }} >
                        <MDBCol xl="12" lg="12" md="12" sm="12">
                            <div className="infoCard">
                                <Card className="editCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
                                    <CardMedia
                                        style={{ height: "0px" }}
                                    />
                                    <CardHeader></CardHeader>
                                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>

                                        {this.state.actionType === "VIEW" ?
                                            <div className="topIcon" style={{ padding: '0px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Image
                                                    width="100%"
                                                    height="100%"
                                                    style={{ objectFit: 'cover' }}
                                                    src={this.state.img}
                                                />
                                            </div>
                                            :
                                            <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                                                <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>spa</span>
                                            </div>
                                        }


                                        <div className="tableTitle" style={{
                                            display: 'inline-block', marginTop: '-60px',
                                            marginLeft: '0', marginRight: '0'
                                        }}>
                                            <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                                        </div>
                                    </div>
                                    <MainCardContent
                                        state={this.state}
                                        isRTL={this.props.isRTL}
                                        allStrings={allStrings}
                                        submitHandler={this.submitHandler}
                                        changeHandler={this.changeHandler}
                                        deleteRequest={this.delete}
                                        notAvailable={this.notAvailable}
                                        fileChangedHandler={this.fileChangedHandler}
                                        removeFile={this.removeFile}
                                        handleChangeState={this.handleChangeState}
                                        headers={headers}
                                        canSeeReport={canSeeReport}
                                        toggle={this.toggle}
                                        canDoFinancialCollection={canDoFinancialCollection}
                                        toggleMedia={this.toggleMedia}
                                    />

                                </Card>
                            </div>
                        </MDBCol>
                    </MDBRow>
                    {this.state.actionType === "VIEW" &&
                        <MediaTable
                            state={this.state}
                            props={this.props}
                            allStrings={allStrings}
                            removeAsset={this.removeAsset}
                            toggleMedia={this.toggleMedia}
                            onPageChange={this.getProjectAssets}
                        />
                    }
                    {this.state.actionType === "VIEW" &&
                        <AttachmentsTable
                            state={this.state}
                            props={this.props}
                            allStrings={allStrings}
                            removeAttachment={this.removeAttachment}
                            toggleAttachment={this.toggleAttachment}
                            onPageChange={this.getProjectAttachments}
                        />
                    }
                    {this.state.actionType === "VIEW" &&
                        <CampaignsTable
                            state={this.state}
                            props={this.props}
                            allStrings={allStrings}
                            removeCampaign={this.removeCampaign}
                            toggleCampaign={this.toggleCampaign}
                            onPageChange={this.getProjectCampaigns}
                        />
                    }
                </MDBContainer>

            </div>
        )
    }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(ProjectInfo)
);